<div class="modal-header" *ngIf="title"><div [ngClass]="titleClasses">{{ title }}</div></div>
<div class="modal-body">
    <div class="d-block text-primary mb-3">{{ text }}</div>
    <div class="d-block text-primary" *ngIf="text2">{{ text2 }}</div>
</div>
<div class="d-flex justify-content-end">
    <button class="btn rounded-pill btn-primary-gradient text-white fw-500 m-3" data-cy="closeQuoteHelpModal" (click)="close()" tabindex="-1"><div class="mx-3">Cool</div></button>
</div>
